import React from "react";
import { Card, Illustration, Text } from "@jsq/ds/core";
import {
  celebrationWrapper,
  celebrationTextWrapper,
  celebrationMsgWrapper,
} from "./style_vanilla.css";

export const Celebration = () => {
  return (
    <Card className={celebrationWrapper} padding="md">
      <Illustration name="celebration" data-testid="illustration-celebration" />
      <Text className={celebrationTextWrapper} variant="h3">
        All done!
      </Text>
      <Text className={celebrationMsgWrapper} variant="regular-md">
        You may close this tab
      </Text>
    </Card>
  );
};
